import React, { useEffect, useRef, useState } from 'react';

import { PaperPlane } from 'src/components/icons';

export type Props = {
  onSend?: (text: string) => void | Promise<void>;
  onEsc?: () => void;
};

const TextArea: React.FC<
  React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > &
    Props
> = ({ onSend, value, onEsc, ...rest }) => {
  const [text, setText] = useState<string>(String(value || ''));
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className="text_area_wrapper">
      <textarea
        {...rest}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
        }}
        rows={3}
        className="text_area"
        onKeyDown={(event) => {
          if (event.keyCode === 27) {
            onEsc?.();
          }
        }}
        ref={ref}
      />
      <div
        className="text_area_send"
        onClick={() => {
          if (!text) return;

          onSend?.(text);
          setText('');
        }}
      >
        <PaperPlane />
      </div>
    </div>
  );
};

export default TextArea;
